import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import moment from 'moment';
import WorkroomSelect from 'components/formElements/WorkroomSelect';
import DatePicker from 'components/DatePicker';
import ColoredButton from 'components/ColoredButton';
import { handleDateSave } from '../../../../../../../utils/dateUtils.js';
import reportStyle from 'styles.scss';
import { DISPLAY_DATE } from '../../../../../../../shared/config/constants.js';

class TagsBulkExportFilters extends React.Component {
  constructor(props) {
    super(props);

    const startingState = {
      workroom_id: parseInt(props.location.query.workroom_id, 10) || null,
      date_received: props.location.query.date_received || moment().format('YYYY-MM-DD'),
      error: '',
    };

    this.state = startingState;
  }

  onWorkroomChange = (selected = []) => {
    const workroom_id = Array.isArray(selected) ? (selected[0] || {}).value || null :
      (selected || {}).value || null;
    return this.setState({ workroom_id, error: '' });
  }

  onDateChange = date =>
    this.setState({ date_received: handleDateSave(date) });

  setError = () =>
    this.setState({ error: 'Please select a workroom' });

  submit = (e) => {
    e.preventDefault();
    if (!this.state.workroom_id) return this.setError();
    const query = { ...this.state };
    delete query.error;
    if (this.props.onSubmit) return this.props.onSubmit(query);

    return this.props.push({ pathname: this.props.location.pathname, query });
  }

  render = () => {
    const date = moment(this.state.date_received).format(DISPLAY_DATE);
    return (<form onSubmit={this.submit} className={reportStyle.form}>
      <WorkroomSelect
        className={reportStyle.formElement}
        multi={false}
        resetValue={null}
        onChange={this.onWorkroomChange}
        value={this.state.workroom_id}
        error={this.state.error}
        required
      />
      <DatePicker
        className={reportStyle.formElement}
        label="Date"
        value={date}
        onChange={this.onDateChange}
        placeholder="Select Date"
        required
      />
      {this.props.children}
      <ColoredButton type="submit">List Tags</ColoredButton>
      {/* Spacing issues between the list tags and print selected tags
      button. I could have spent 2 hours fixing this with css, or just
      used html spaces instead. I guess I went the lazy route but if
      anyone reads this and feels like this is TOO lazy, I'll work on
      it gladly */}
      &nbsp;&nbsp;&nbsp;
      { this.props.showPrint && <ColoredButton
        type="button"
        onClick={() => this.props.handlePrint()}
      >
        Print Selected Tags
      </ColoredButton> }
    </form>);
  }
}

TagsBulkExportFilters.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    query: PropTypes.shape({
      workroom_id: PropTypes.string,
      date_received: PropTypes.string,
    }),
  }).isRequired,
  someSelected: PropTypes.bool,
  push: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  children: PropTypes.node,
  showPrint: PropTypes.bool,
  handlePrint: PropTypes.func,
};

export default connect(() => ({}), { push })(TagsBulkExportFilters);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/reports/tags/components/TagsBulkPrintFilters/index.jsx